import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);


const store = new Vuex.Store({
    plugins: [createPersistedState()],
    state: {
        token: null,
        userName: null,
        firstName:null,
        parentEmail: null,
        userId: null,
        studentProfileId: null,
        parentProfileId:null,
        userProfileId:null,
        userType:null,
        multiple_schools:false,
        didWatch:null,
        studentIndividualProject: [],
        graduationProject:[],
        hasVisitedIde: 0,
        isSchoolStudent:0,
        allowLessonLocking:0,
        allowfinishLessons:0,
        isTutorialActive: true,
        message: {},
        loginMessage: {},
        courseDetails: {},
        courseId:null,
        lessonPreVideo: {},
        ideInfo: {},
        imageCateg: [],
        imagesByCateg: [],
        soundCateg: [],
        soundsByCateg: [],
        studentCourseProjects: [],
        randomCourseProject:[],
        StudentType:false,
        activeCourse:{},
        planObj:{},
        schoolId:null,
        isGoalVisited:true,
        graduationProjectPlayground:{},
        isVisited:0,
        points:0,
        showTopTenModal:false,
        showCompetitionModal:false,
        WhatsApp:true,
        isTrial:null,
        competitionInfo:{},
        isFirstLogin:true,
        studentfinishFirstFreeLesson:false,
        studentfinishSecondFreeLesson:false,
        studentfinishThirdFreeLesson:false,
        studentfinishForthFreeLesson:false,
        studentfinishFifthFreeLesson:false,
        isComeFromGrants:false,
        competitionPlan:{},
        subscribeNowDiscount:'',
        subscribePlanId:null,
        cliantInfo:null,
        LastName:null,
        studentfinishBasicSmoothy:false,
        studentfinishIntermediateSmoothy:false,
        studentfinishAdvancedSmoothY:false,
        studentfinishExpertSmoothY:false,
        studentfinishHTML:false,
        img_uri: null,
        student_iec:false,
        postId: 0
    },
    mutations,
    actions,
    getters,
})
export default store;



// WEBPACK FOOTER //
// ./src/store/store.js